import { useState, useEffect } from "react";
import { useStoreContext } from "../context/siteContext";

function useRequireAuth() {
  const { customerToken, customerEmail, customerName, customerAddress } =
    useStoreContext();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [customer, setCustomer] = useState(null);

  useEffect(() => {
    if (customerToken && customerEmail && customerName && customerAddress) {
      setIsAuthenticated(true);
      setCustomer({
        customerToken,
        customerEmail,
        customerName,
        customerAddress,
      });
    }
    return () => {};
  }, [customerToken]);

  return [isAuthenticated, customer];
}
export default useRequireAuth;
